import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const ActionButton = (props) => {
    return _jsx(_Fragment, { children: props.href
            ? _jsx("a", { href: props.href, className: `btn btn-sm btn-${props.style || 'primary'} px-1 py-0 ms-1`, title: props.title, children: _jsx("i", { className: `bi bi-${props.icon}` }) })
            : _jsx("button", { type: "button", onClick: props.onClick, className: `btn btn-sm btn-${props.style} px-1 py-0 ms-1`, title: props.title, children: _jsx("i", { className: `bi bi-${props.icon}` }) }) });
};
export const ActionButtonAuditLog = (props) => {
    return _jsx(ActionButton, { href: `#/audit-log/${props.kind}/${props.id}`, style: "outline-secondary", icon: "file-earmark-diff", title: "Audit Log", blank: true });
};
export default ActionButton;
